module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassic-Regular-f71cfc49e5017ad556c5149032f2a730.otf";